const JiclPreviewEmptySection = () => (
  <div className='jicl-preview-empty-section'>
    <div>No Information entered</div>
    <div>This section will be hidden from your recipients</div>
  </div>
)

export default JiclPreviewEmptySection
